
import { defineComponent } from "vue";
import Grid from "@moonlight/vue3/components/Grid.vue";
import Row from "@moonlight/vue3/components/Row.vue";
import Col from "@moonlight/vue3/components/Col.vue";
import Button from "@moonlight/vue3/components/Button.vue";
import { trans } from "@/globals/translator";

export default defineComponent({
  components: {
    Grid,
    Row,
    Col,
    Button,
  },
  setup() {
    return {
      trans,
    };
  },
});
